import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelpPopupService {
  public visible: boolean;
}
